<template>
    <div :class="'search float-'+float">
        <b-input-group class="my-3">
            <b-form-input 
                type="text" 
                v-model="search"
                :placeholder="placeholder"
                @keyup.enter="SearchFunction">
            </b-form-input>
            <b-input-group-append>
                <b-input-group-text class="searchinput"  @click="SearchFunction">
                    <b-icon icon="search" />
                </b-input-group-text>
            </b-input-group-append>
        </b-input-group>
    </div>
</template>
<script>
export default {
    props: {
        clickHandler: {
            type: Function,
            default: () => { }
        },
        float:{
            Type: String, default: ''
        },
        placeholder:{
            type: String,
            default: '',
        },
    },
    data() {
        return{
            search: '',
        }
    },
    methods:{
        SearchFunction(){
            this.clickHandler(this.search)
        },
    }
}
</script>
<style lang="scss" scoped>
    .searchinput{
        cursor: pointer;
    }
</style>